










import Vue from 'vue'
import { nl2br, autoLink } from '@/utils'

export default Vue.extend({
  name: 'DetailCard',
  props: {
    thumb: {
      type: String,
      required: true
    },
    thumbUploaded: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  computed: {
    thumbImage(): string {
      if (this.thumbUploaded) {
        return this.thumb
      } else {
        return require(`@/assets/images/benefit_placeholder.png`)
      }
    }
  },
  methods: {
    formatText: (s: string): string => {
      return autoLink(nl2br(s), '_blank')
    }
  }
})
